import { Component, OnInit } from '@angular/core';
import { Router} from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { faFileContract} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-agserhomes',
  templateUrl: './agserhomes.component.html',
  styleUrls: ['./agserhomes.component.scss']
})
export class AgserHomesComponent implements OnInit {

    public latitude: Number;
    public longitude: Number;
    public zoom: Number;
    public faFileAlt = faFileContract;

  constructor(private router: Router, private http : HttpClient) { }

  ngOnInit(): void {
    window.scroll(0,0);
    this.latitude = 12.9997972;
    this.longitude = 77.9368727;
    this.zoom = 12;
  }

 
}
